import type { LogLevel, LogMeta, SentryLike } from './types'

export function handleSentry(sentry: SentryLike | undefined, level: LogLevel, message: string, meta: LogMeta): void {
  if (!sentry || !meta.sentry) {
    return
  }

  // Build tags/extras from meta, excluding internal flags
  const { sentry: _s, index: _i, error, data: _data, ...rest } = meta
  const extras = Object.keys(rest).length > 0 ? rest : undefined

  if (level === 'error' && error) {
    sentry.captureException(error, extras ? { extra: extras } : undefined)
  } else if (level === 'error') {
    sentry.captureMessage(message, 'error')
  } else if (level === 'warn') {
    sentry.captureMessage(message, 'warning')
  } else {
    sentry.captureMessage(message, level)
  }
}

export function addBreadcrumb(
  sentry: SentryLike | undefined,
  level: LogLevel,
  namespace: string,
  message: string,
  meta?: Record<string, unknown>
): void {
  if (!sentry) {
    return
  }

  sentry.addBreadcrumb({
    category: namespace,
    message,
    level,
    data: meta
  })
}
